import dynamic from 'next/dynamic';

import { PageSeo } from 'components/common';
import { AccountLayout } from 'components/layout';
import { TRANSLATIONS } from 'constants/translations';
import withAuth from 'hoc/WithAuth/withAuth';
import { withSSGPage } from 'hoc/WithServerPage/withSSGPage';
import { useTranslation } from 'hooks/common/useTranslation';

import type { NextPageWithLayout } from 'types';
import { PageType } from 'types';

const AccountDetailsTemplate = dynamic(() => import('templates/Account/AccountDetails/AccountDetailsTemplate'), { ssr: false });

export const getStaticProps = withSSGPage(async () => {
  return {
    props: {}
  };
}, {
  translations: [TRANSLATIONS.COMMON, TRANSLATIONS.ACCOUNT],
  pageType: PageType.AccountDetails,
  revalidate: false
});

const Page: NextPageWithLayout<PageType.AccountDetails> = withAuth(() => {
  const { t } = useTranslation();
  return (
    <>
      <PageSeo seoProps={{ title: t('NAVIGATION.ACCOUNT.LOGGED_IN.ACCOUNT') }} />
      <AccountDetailsTemplate />
    </>
  );
});

Page.getLayout = (page) => {
  return (
    <AccountLayout>
      {page}
    </AccountLayout>
  );
};

export default Page;
